import { axClient } from "./axios-mixins";

export let LoginMixins = {
    data: {
        modalLogin: {
            username: "",
            password: "",
            showErrors: false,
            disableSubmitBtn: false
        }
    },
    methods: {
        modalLoginSend: function() {
            let vm = this;
            let data = new FormData();
            data.append("username", vm.modalLogin.username);
            data.append("password", vm.modalLogin.password);
            vm.modalLogin.showErrors=false;
            vm.modalLogin.disableSubmitBtn=true;
            axClient.post('/login/authenticate', data, function (resp) {
                if (resp.data.success) {
                    const elModal = document.getElementById("modal-login-form")
                    if (elModal?.getAttribute("data-usedefault") === "true") {
                        window.location = elModal.getAttribute("data-targeturl")
                    } else {
                        window.location.reload();
                    }
                } else {
                    window.location = "/login/auth?login_error=1&redirect="+window.location.href;
                }
            });
        }
    }
}